import { Controller } from "@hotwired/stimulus"
import React, { Suspense } from "react"
import { render, unmountComponentAtNode } from "react-dom"
import { BrowserRouter as Router } from "react-router-dom"
import { ErrorBoundary, Loading, ModalContainer } from "web/components"
import { GlobalTopicList } from "web/components/Topic"
import { NavigationProvider } from "web/contexts"
import { AppProviders, LibraryProviders } from "web/Providers"

export default class GlobalTopicListController extends Controller {
  static values = {
    subjectType: String,
    subjectId: Number,
    topicName: String,
    basePath: String,
    viewGroup: Object,
    viewId: Number,
  }

  initialize() {
    global.React = React
  }

  connect() {
    render(
      <Suspense fallback={<Loading />}>
        <Router>
          <LibraryProviders>
            <AppProviders>
              <NavigationProvider
                viewGroup={this.viewGroupValue}
                viewId={this.viewIdValue}
                subjectType={this.subjectTypeValue}
              >
                <ErrorBoundary>
                  <GlobalTopicList
                    subjectType={this.subjectTypeValue}
                    route={[{ key: this.topicNameValue }]}
                    rootUrl={this.basePathValue}
                    canRedirectToRootUrl={false}
                  />
                </ErrorBoundary>
              </NavigationProvider>
              <ModalContainer />
            </AppProviders>
          </LibraryProviders>
        </Router>
      </Suspense>,
      this.element
    )
  }

  disconnect() {
    unmountComponentAtNode(this.element)
  }
}
